/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react'
import styles from './style.module.scss'
import MyImage from '@shared/components/myImage'

const dummyData = [
  {
    date: '2024-10-03'
  },
  {
    date: '2024-10-04'
  },
  {
    date: '2024-10-05'
  },
  {
    date: '2024-10-06'
  },
  {
    date: '2024-10-07'
  },
  {
    date: '2024-10-08'
  },
  {
    date: '2024-10-09'
  },
  {
    date: '2024-10-10'
  },
  {
    date: '2024-10-11'
  }
]

const LeagueTimeline = ({ data }) => {
  const leagueData = data?.getGCLSchedule?.oFixtures

  const compareDates = (apiDateStr, otherDateStr) => {
    const apiDate = new Date(apiDateStr)
    const otherDate = new Date(otherDateStr)
    return apiDate.toDateString() === otherDate.toDateString()
  }

  const [selectedDate, setSelectedDate] = useState('')
  const [currentMatches, setCurrentMatches] = useState([])

  useEffect(() => {
    const today = new Date()
    const startDate = new Date('2024-10-03')
    const endDate = new Date('2024-10-11')

    let dateToShow
    if (today < startDate) {
      dateToShow = startDate
    } else if (today > endDate) {
      dateToShow = endDate
    } else {
      dateToShow = today
    }

    const formattedDate = dateToShow.toISOString().split('T')[0]
    setSelectedDate(formattedDate)
    setCurrentMatches(leagueData.filter(day => compareDates(day.dIndiaTime, formattedDate)) || [])
  }, [])

  const handleDateClick = day => {
    setSelectedDate(day?.date)
    setCurrentMatches(leagueData.filter(d => compareDates(d.dIndiaTime, day?.date)) || [])
  }

  function convertDt12hFormat(dateTime) {
    const [date, time] = dateTime.split(' ')

    let [hours, minutes, seconds] = time.split(':')

    hours = parseInt(hours, 10)

    const suffix = hours >= 12 ? 'PM' : 'AM'

    hours = hours % 12 || 12

    return `${hours}:${minutes} ${suffix}`
  }

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>League Timeline</h2>
      <div className={`${styles.timeline} scroll-list`}>
        {dummyData.map(day => (
          <div key={day.date} className={styles.dateColumn}>
            <div className={`${styles.dateNode} ${day.date === selectedDate ? styles.active : ''}`} onClick={() => handleDateClick(day)}>
              <span />
            </div>
            <div className={`${styles.dateLabel}`}>
              {new Date(day.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
            </div>
            {/* <div className={`${styles.dateLabel} d-flex d-md-none`}>
              {new Date(day.date).toLocaleDateString('en-US', { day: 'numeric' })}
            </div>
            <div className={`${styles.dateLabel} d-flex d-md-none`}>
              {new Date(day.date).toLocaleDateString('en-US', { month: 'short' })}
            </div> */}
          </div>
        ))}
      </div>
      <div className={styles.matches}>
        {currentMatches?.map((match, index) => (
          <div key={index} className={styles.match}>
            <div className={styles.teamLogos}>
              <div className={`${styles.team} w-full d-flex text-center align-items-center flex-column`}>
                <MyImage src={match?.oTeamA?.oImg?.sUrl} alt="Continental Kings" height={42} width={42} />
                <span className={styles.teamTitle}>{match?.oTeamA?.sTitle}</span>
              </div>
              <span className={styles.vsText}>VS</span>
              <div className={`${styles.team} w-full d-flex text-center align-items-center flex-column`}>
                <MyImage src={match?.oTeamB?.oImg?.sUrl} alt="Mumbai Masters" height={42} width={42} />
                <span className={styles.teamTitle}>{match?.oTeamB?.sTitle}</span>
              </div>
            </div>
            <div className={`${styles.matchDetail} text-center`}>
              <div className={styles.matchTime}>
                <div className={styles.timeTitle}>India Time</div>
                <div className={styles.timeValue}>{convertDt12hFormat(match?.dIndiaTime)}</div>
              </div>
              <div className={styles.matchTime}>
                <div className={styles.timeTitle}>UK Time</div>
                <div className={styles.timeValue}>{convertDt12hFormat(match?.dUKTime)}</div>
              </div>
              <div className={styles.matchTime}>
                <div className={styles.timeTitle}>#Match</div>
                <div className={styles.timeValue}>Match {match?.nMatchNumber}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default LeagueTimeline
